/**
 * Shared utilities for entity search functionality
 */

import type { EntityType } from './types';

/**
 * Type guard to validate if a string is a canonical EntityType.
 * Used to prevent invalid types from bypassing TypeScript safety.
 */
export function isEntityType(type: string): type is EntityType {
  return (
    type === 'ahoy_user' ||
    type === 'ahoy_contact' ||
    type === 'ahoy_company' ||
    type === 'ahoy_deal' ||
    type === 'ahoy_note'
  );
}

/**
 * Centralized mapping from canonical entity types to search result keys.
 * Used by EntityInputElement and EntityTypeahead to access results from useEntitySearch.
 */
export const ENTITY_TYPE_TO_RESULT_KEY: Partial<Record<EntityType, string>> = {
  ahoy_user: 'users',
  ahoy_contact: 'contacts',
  ahoy_company: 'companies',
  ahoy_deal: 'deals',
  ahoy_note: 'notes',
};
